import Typography from '@mui/material/Typography';
import { StatItemProps } from './SegmentItem';
import { DEFAULT_UNIT, StatRow, WIDGET_COLORS } from './WidgetPrimitives';

export interface LearningJourneyBreakdown {
 total_count?: number;
  counts?: {
    current?: number;
    on_track?: number;
    in_progress?: number;
    not_started?: number;
  };
  percentages?: {
    current?: number;
    on_track?: number;
    in_progress?: number;
    not_started?: number;
  };
}

interface LearningJourneyProps {
  learningJourney?: LearningJourneyBreakdown;
  attribute: string;
  group: string;
}

const LearningJourney = ({
  learningJourney: {
    total_count: total = 0,
    counts: {
      current: currentCount = 0,
      on_track: onTrackCount = 0,
      in_progress: inProgressCount = 0,
      not_started: notStartedCount = 0
    } = {},
    percentages: {
      current: currentPercent = 0,
      on_track: onTrackPercent = 0,
      in_progress: inProgressPercent = 0,
      not_started: notStartedPercent = 0
    } = {}
  } = {},
  attribute,
  group
}: LearningJourneyProps) => {
  const journeyStat = (percent: number, status: string, label: string, color?: string): StatItemProps => ({
    value: `${percent}%`,
    label,
    color,
    filter: { attribute, value: status, group, label }
  });

  return (

    <div
      style={{
        marginTop: 16,
        border: '1px solid #eee',
        borderRadius: 4,
        padding: 12
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
        <Typography style={{ fontSize: 14, fontWeight: 600 }}>Learning Journey</Typography>
        <div style={{ flexGrow: 1 }} />
        <Typography style={{ fontSize: 14 }}>
          <span style={{ fontWeight: 700 }}>{total}</span>{' '}
          <span style={{ color: WIDGET_COLORS.gray }}>Total {DEFAULT_UNIT}</span>
        </Typography>
      </div>
      <StatRow
        items={[
          journeyStat(currentPercent, 'current', 'Current', WIDGET_COLORS.green),
          journeyStat(onTrackPercent, 'on_track', 'On track', WIDGET_COLORS.blue),
          journeyStat(inProgressPercent, 'in_progress', 'In progress', WIDGET_COLORS.lightBlue),
          journeyStat(notStartedPercent, 'not_started', 'Not started')
        ]}
      />
    </div>
  );
};

export default LearningJourney;
